import { isFeatureEnabled } from 'owa-feature-flags';
import { getUserCulture } from 'owa-session-store';

// This controls whether we should render suggestions returned by the SmartCompose service
export default function shouldShowTextPrediction() {
    return (
        (isFeatureEnabled('mc-smartCompose') ||
            isFeatureEnabled('mc-smartCompose-exp-flight01') ||
            isFeatureEnabled('mc-smartCompose-exp-flight02')) &&
        (getUserCulture() === 'en-US' ||
            getUserCulture() === 'en-CA' ||
            getUserCulture() === 'en-AU' ||
            getUserCulture() === 'en-GB' ||
            getUserCulture() === 'en-NZ')
    );
}
